// Module
var code = "<div class=\"well\"> <kform-builder-list component=\"component\" form=\"$ctrl.form\" options=\"$ctrl.options\"></kform-builder-list> </div> ";
// Exports
export default code;